import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontMedium } from 'src/styles/font';
import { MediaBP } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const CardContainer = styled.div`
  width: calc(50% - 8px);
  min-width: 96px;
  ${flex('column')};
  cursor: pointer;
  ${MediaBP.MediaLg} {
    width: 100%;
  }
`;

export const Container = styled.div`
  width: 100%;
  border-radius: 4px;
  ${flex('column', 'space-between', 'start')};
  padding: 8px;
  height: 90px;
  transition: all 0.2s;
  ${MediaBP.MediaSm} {
    height: 104px;
  }
  ${MediaBP.MediaLg} {
    height: 140px;
  }
  ${MediaBP.MediaXl} {
    height: 127px;
  }
`;

export const roundedBorder = css`
  border-radius: 4px;
  ${MediaBP.MediaLg} {
    border-radius: 4px;
  }
`;
export const BestPlanContainer = styled.div`
  ${flex('column', 'start', 'start')};
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  gap: 4px;
  border-image: linear-gradient(90deg, #ff007a, #ff9100, #00ffc6) 1;
`;

export const BestPlanPrice = styled.div`
  ${ZeeFontBold(16, 20)};
  ${MediaBP.MediaLg} {
    ${ZeeFontBold(24, 36)};
  }
`;

export const ValidTimeText = styled.div`
  ${ZeeFontMedium(11, 16)};
  color: ${colors.PlanTitleGrey};
  ${MediaBP.MediaLg} {
    ${ZeeFontMedium(14, 18)};
  }
`;

export const ValidTime = styled.div`
  ${ZeeFontMedium(16, 20)};
  color: ${colors.PrimaryWhiteColor};
  margin-top: 8px;
  ${MediaBP.MediaLg} {
    ${ZeeFontMedium(18, 24)};
  }
`;

export const CurrentPlanBadge = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 5px;
  span {
    width: fit-content;
    display: flex;
    padding: 4px 6px;
    border-radius: 12px;
    border: 1px solid #ffffff3d;
    justify-content: center;
    ${ZeeFontBold(8)};
    color: #332b0c;
    background: linear-gradient(86.55deg, #c6c6c6 0%, #b4b4bf 100%);
  }
`;

export const BestPlanTitle = styled.div`
  margin-top: -4px;
  color: ${colors.PlanTitleGrey};
  ${ZeeFontBold(12, 18)};
  ${MediaBP.MediaLg} {
    ${ZeeFontBold(18, 24)};
  }
`;

export const greyContainer = css`
  border: 1px solid ${rgba(colors.PrimaryWhiteColor, 0.12)};
  background: ${colors.PlanCardGray};
`;

export const goldContainer = css`
  border: 1px solid ${colors.YellowGold};
  background: linear-gradient(
      327deg,
      rgba(37, 29, 44, 0) -11.65%,
      #5a5438 50.11%,
      #ccb13e 159.3%
    ),
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.24) 0%,
      rgba(102, 102, 102, 0.24) 100%
    );
  ${MediaBP.MediaLg} {
    border-radius: 0 0 2px 2px;
  }
`;

export const lavendarContainer = css`
  border: 1px solid ${colors.LavendarLight};
  background: linear-gradient(
      327deg,
      rgba(37, 29, 44, 0)-11.65%,
      rgba(194, 151, 229, 0.21) 40.5%,
      rgba(158, 48, 248, 0.74) 118.86%
    ),
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.24) 0%,
      rgba(102, 102, 102, 0.24) 100%
    );
  ${MediaBP.MediaLg} {
    border-radius: 0 0 2px 2px;
  }
`;

export const premiumContainer = css`
  border: 1px solid #dbc776;
  background: linear-gradient(
    327deg,
    rgba(50, 29, 44, 0) -13.65%,
    #5a5438 52.11%,
    #ccb13e 115%
  );
`;

export const Badge = styled.div`
  width: fit-content;
  padding: 2px 4px;
  gap: 4px;
  border-radius: 4px;
  color: ${colors.PrimaryBlackColor};
  background: ${colors.LavendarLight};
  ${ZeeFontMedium(8, 11)};
  text-align: center;
  ${MediaBP.MediaSm} {
    ${ZeeFontMedium(10, 12)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontMedium(12, 15)};
  }
`;

export const TagContainer = styled.div`
  border-radius: 2px 2px 0 0;
  text-align: center;
  padding: 0 4px;
  ${ZeeFontMedium(10, 16)}
  color: ${colors.PrimaryBlackColor};
  width: fit-content;
  ${MediaBP.MediaLg} {
    width: 100%;
    padding: 2px 4px;
    ${ZeeFontMedium(12, 16)};
  }
  ${MediaBP.MediaXl} {
    padding: 4px 4px;
    ${ZeeFontMedium(14, 16)};
  }
`;

export const goldTag = css`
  background-color: ${colors.YellowGold};
`;

export const lavendarTag = css`
  background-color: ${colors.LavendarLight};
`;

export const grayTag = css`
  background-color: ${colors.TagGray};
  color: ${colors.white};
`;

export const greenTag = css`
  background-color: ${colors.TagGreen};
`;

export const Title = styled.div`
  ${ZeeFontBold(12, 18)};
  color: ${colors.PlanTitleBluishGrey};
  marginp-bottom: 4px;
  ${MediaBP.MediaSm} {
    ${ZeeFontBold(12, 18)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontBold(14, 20)};
  }
  ${MediaBP.MediaLg} {
    ${ZeeFontBold(16, 20)};
  }
  &[data-selected='true'] {
    color: ${colors.PlanTitleSelectedBluishPurple};
  }
`;

export const Subtitle1 = styled.div`
  margin-top: -4px;
  ${ZeeFontMedium(14, 20)};
  ${MediaBP.MediaSm} {
    ${ZeeFontMedium(16, 22)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontMedium(18, 24)};
  }
  ${MediaBP.MediaLg} {
    ${ZeeFontBold(24, 36)};
  }
  &[data-selected='true'] {
    color: ${colors.PrimaryBlackColor};
  }
`;

export const Subtitle2 = styled.div`
  ${ZeeFontMedium(10, 12)};
  text-decoration: line-through;
  color: ${colors.FeatureGrey};
  ${MediaBP.MediaMd} {
    ${ZeeFontMedium(14, 17)};
  }
  &[data-selected='true'] {
    color: ${colors.PrimaryBlackColor};
  }
`;

export const TextContainer = styled.div`
  position: relative;
  width: 100%;
  bottom: 0px;
`;

export const noBorderTop = css`
  ${MediaBP.MediaLg} {
    border-top: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
`;

export const transparentBadge = css`
  background-color: ${colors.Transparent};
`;

export const PlanCardWrapper = styled.div`
  background-color: #090912;
  border-radius: 12px;
  padding: 14px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  color: white;
  box-shadow: 0 0 16px rgba(255, 255, 255, 0.05);
  width: 100%;
  max-width: 640px;
  margin: 0;
  border: 1px solid #888;
  min-width: 100%;
`;

export const PremiumPlanCardWrapper = css`
  background: linear-gradient(#0d0b14, #0d0b14) padding-box,
    /* inner background */ linear-gradient(90deg, #ff007a, #ff9100, #00ffc6)
      border-box; /* border */
  border: 1px solid transparent;
  border-radius: 12px;
  background-origin: border-box;
  background-clip: padding-box, border-box;
`;

export const ActivePlanCardWrapper = css`
  background: white;
  color: black;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.05);
`;

export const LeftSection = styled.div`
  display: flex;
  flex: 8;
  align-items: flex-start;
`;

export const RadioCircleWrapper = styled.div`
  align-self: center;
  margin-right: 12px;
`;
export const RadioCircle = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  margin-right: 12px;
  align-self: center;
  position: relative;
  &[data-selected='true'] {
    border: 2px solid ${colors.PrimaryBlackColor};
  }
  &[data-selected='true']::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    background-color: ${colors.PrimaryBlackColor};
    border-radius: 50%;
  }
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Logo = styled.div`
  display: flex;
  justify-content: space-between;
  img {
    height: 23px;
  }
`;

export const DeviceInfo = styled.div<{ active?: boolean }>`
  font-size: 10px;
  color: ${({ active }) =>
    active ? colors.PlanTitleSelectedBluishPurple : colors.white};
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 16px;
    height: 16px;
  }
  ${MediaBP.MediaLg} {
    font-size: 13px;
  }
`;

export const RightSection = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  text-align: right;
  align-self: flex-start;
`;

export const OldPrice = styled.div<{ active?: boolean }>`
  ${ZeeFontMedium(14, 20)};
  color: ${({ active }) =>
    active ? colors.OldPriceGreyishPurpleBlue : colors.PlanTitleGrey};
  text-decoration: line-through;
`;

export const CurrentPrice = styled.div<{ active?: boolean }>`
  ${ZeeFontBold(18, 24)}
  color: ${({ active }) =>
    active ? colors.PlanTitleSelectedBluishPurple : colors.PlanTitleBluishGrey};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 10px;
  ${MediaBP.MediaLg} {
    font-size: 16px;
    margin-top: 4px;
  }
`;
